import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { apiFetch } from "./api/client";
import { UI } from "./designSystem";
import { getEffectiveRoles } from "./roleSimulator";
import AdminMembros from "./AdminMembros";
import AdminMembrosConsulta from "./AdminMembrosConsulta";

// Voltar dessas telas de administração deve ir pro painel de admin (/admin),
// não pro site.
const ADMIN_PATH = "/admin";

// Ponto de entrada UNICO pra "Membros" -- antes existiam dois cards/rotas
// separados (/admin/membros e /admin/membros-consulta) que a pessoa
// precisava escolher primeiro, mesmo o ADMIN vendo os dois ao mesmo tempo
// no painel (pergunta do Rodrigo: "por que 2 telas, nao poderia ser so
// permissao?"). Este portal decide sozinho, pelo papel de quem esta
// logado, qual das duas telas mostrar:
//   - ADMIN ou SECRETARIA -> AdminMembros.jsx (cadastro completo, /members)
//   - SECRETARIA_CONSULTA -> AdminMembrosConsulta.jsx (visao reduzida-LGPD,
//     /members/directory -- sem CPF, endereco, contato ou anotacoes)
// Os dois componentes continuam EXATAMENTE como antes por dentro (mesma
// checagem de permissao, mesmos endpoints, mesmos campos) -- a decisao de
// qual chamada de API e' feita e quais campos existem continua no
// componente de destino (e no backend, no caso do endpoint reduzido), nunca
// aqui. Este portal so decide QUAL dos dois abrir; ele passa `portalAccess`
// pro filho pra este nao bater /auth/me de novo (evitaria um segundo
// "Carregando..." piscando por cima do que o portal ja resolveu).
export default function AdminMembrosPortal() {
  const [mode, setMode] = useState("checking"); // checking | full | consulta | forbidden

  useEffect(() => {
    let alive = true;
    apiFetch("/auth/me", { method: "GET", skipSessionExpiredHandler: true })
      .then((me) => {
        if (!alive) return;
        if (me.passwordMustChange) {
          setMode("forbidden");
          return;
        }
        const effectiveRoles = getEffectiveRoles(me);
        if (effectiveRoles.includes("ADMIN") || effectiveRoles.includes("SECRETARIA")) {
          setMode("full");
        } else if (effectiveRoles.includes("SECRETARIA_CONSULTA")) {
          setMode("consulta");
        } else {
          setMode("forbidden");
        }
      })
      .catch(() => {
        if (alive) setMode("forbidden");
      });
    return () => {
      alive = false;
    };
  }, []);

  if (mode === "checking") {
    return (
      <div
        style={{
          minHeight: "100vh",
          width: "100%",
          boxSizing: "border-box",
          backgroundColor: UI.shell,
          color: UI.text,
          fontFamily: "'DM Sans', system-ui, sans-serif",
          padding: "28px 20px 60px"
        }}
      >
        <div style={{ maxWidth: 480, margin: "18vh auto 0", textAlign: "center" }}>
          <p style={{ margin: 0, color: "#c7ced9", fontSize: 14, lineHeight: 1.6 }}>Carregando...</p>
        </div>
      </div>
    );
  }

  if (mode === "forbidden") {
    return (
      <div
        style={{
          minHeight: "100vh",
          width: "100%",
          boxSizing: "border-box",
          backgroundColor: UI.shell,
          color: UI.text,
          fontFamily: "'DM Sans', system-ui, sans-serif",
          padding: "28px 20px 60px"
        }}
      >
        <div style={{ maxWidth: 480, margin: "18vh auto 0", textAlign: "center" }}>
          <p style={{ margin: 0, color: "#c7ced9", fontSize: 14, lineHeight: 1.6 }}>
            Esta página é restrita à secretaria (inclusive papel de consulta) e administradores.
          </p>
          <Link
            to={ADMIN_PATH}
            style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "#9fb0cc", fontSize: 13, fontWeight: 700, textDecoration: "none", marginTop: 18, justifyContent: "center" }}
          >
            <ArrowLeft size={14} /> Voltar
          </Link>
        </div>
      </div>
    );
  }

  if (mode === "consulta") {
    return <AdminMembrosConsulta portalAccess />;
  }

  return <AdminMembros portalAccess />;
}
